import styled from 'styled-components';
import { ActiveOfferInfo } from '../../../../../components/Offers';
import { useNoSelectorVehicleOfferAuctionById } from '../../../../../hooks';
import { useCurrentUser } from '../../../../../hooks/selectors';
import StatusComponent from '../../../../Shared/VehicleDetails/RoleRestrictedSection/BuyerRestrictionSection/StatusComponent';
import { useViewedVehicle } from '../../hooks/useViewedVehicle';
import { InfoBlock } from '../InfoBlock';
import { BuyerActiveOffers } from './Buyer';
import SellerActiveOffers from './Seller';
import { AdminActions } from './Admin';

const Wrapper = styled.div`
  padding: 16px;
  display: flex;

  &:empty {
    display: none;
  }
`;

export const UserActions = () => {
  const vehicle = useViewedVehicle();
  const currentUser = useCurrentUser();
  if (!vehicle) return null;

  if (currentUser.role === 'buyer') {
    return (
      <InfoBlock>
        <Wrapper>
          <BuyerActiveOffers vehicle={vehicle} />
        </Wrapper>
      </InfoBlock>
    );
  }

  if (currentUser.role === 'admin') {
    return <AdminActions />;
  }

  if (currentUser.role === 'seller') {
    return <SellerActiveOffers />;
  }

  return null;
};
